import { render, staticRenderFns } from "./LicenseInfo.vue?vue&type=template&id=2436f530&"
import script from "./LicenseInfo.vue?vue&type=script&lang=ts&"
export * from "./LicenseInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports